export default "__VITE_ASSET__46f95a5f__"